import { Participant } from '@model/participant';

export type ActivityImagePath = `assets/images/activity.${string}.png`;

/**
 * Builds the image path for a participant's activity icon.
 *
 * The path has the form `assets/images/activity.{activity}.png` where
 * `{activity}` is the value of `participant.activity`.
 *
 * @param participant Participant whose activity image URL is requested.
 * @returns A typed activity image path or `undefined` when no activity is set.
 */
export const activityImageUrl = (
  participant: Participant,
): ActivityImagePath | undefined =>
  participant.activity
    ? `assets/images/activity.${participant.activity}.png`
    : undefined;

/**
 * Enriches a participant with a normalized and guaranteed image URL.
 *
 * @param participant Source participant data.
 * @returns A participant with a valid `imageUrl` set.
 */
export const enrichParticipant = (participant: Participant): Participant => ({
  ...participant,
  imageUrl: participant.imageUrl ?? 'assets/images/participant.png',
});
